import { render, staticRenderFns } from "./messagebox.vue?vue&type=template&id=38cf7eda&"
import script from "./messagebox.vue?vue&type=script&lang=js&"
export * from "./messagebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports